var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#F4F5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8823 15.667V16.6426C21.8823 16.9502 21.7725 17.2183 21.5527 17.4468C21.3418 17.6665 21.0825 17.7764 20.7749 17.7764H11.8364C11.5288 17.7764 11.2651 17.6665 11.0454 17.4468C10.8345 17.2183 10.729 16.9502 10.729 16.6426V15.667C10.729 15.3594 10.8345 15.1001 11.0454 14.8892C11.2651 14.6694 11.5288 14.5596 11.8364 14.5596H20.7749C21.0562 14.5596 21.311 14.665 21.5396 14.876C21.7681 15.0781 21.8823 15.3418 21.8823 15.667Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCollapse);
export default __webpack_public_path__ + "static/media/closeCollapse.38e5822d4b3ed1a953ff4fea3b01948d.svg";
export { ForwardRef as ReactComponent };